'use client';

import { useEffect, useRef } from 'react';

import { datadogRum } from '@datadog/browser-rum';

import { type ProductPrice } from '@/modules/product/types';
import { useSessionId } from '@/modules/storage/useSessionId';

// Adding temporarily to investigate why we're
// seeing upfront shipping for some US users.
export function UpfrontShippingRumTracker({
  pricing,
  countryCode,
}: {
  pricing: ProductPrice;
  countryCode: string;
}) {
  const hasTracked = useRef(false);
  const eventSessionId = useSessionId();

  useEffect(() => {
    if (!hasTracked.current) {
      hasTracked.current = true;
      datadogRum.addAction('upfront_shipping_displayed', {
        ...pricing,
        countryCode,
        eventSessionId,
      });
    }
  }, []);

  return null;
}
